import { gql } from "@apollo/client";

export const UpdateYouTubeVideo = gql`
mutation UpdateYouTubeVideo($content: contentYouTubeVideo!, $updateYouTubeVideoId: ID!) {
  updateYouTubeVideo(content: $content, id: $updateYouTubeVideoId) {
    status
  }
}
`;
